import type { SubmitHandler } from 'react-hook-form';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import authImplementation from '../../shared/auth/auth';
import { Button } from '@mui/material';
import { useState } from 'react';
import Error from './Message';

import type { HelpPayload } from '../../types';
import Input from './Input';
import { useTranslation } from 'react-i18next';
import { buildYupLocale } from './buildYupLocale';
import InputWrapper from './InputWrapper';

type HelpFormProps = {
  setSended: (result: boolean) => void;
};

export const HelpForms = ({ setSended }: HelpFormProps) => {
  const [result, setResult] = useState<null | string>(null);
  const { t } = useTranslation();
  buildYupLocale(t);

  const schema = yup
    .object({
      fullName: yup.string().required(),
      email: yup.string().email().required(),
      subject: yup.string().required(),
      message: yup.string(),
    })
    .required();

  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm<HelpPayload>({
    resolver: yupResolver(schema),
    defaultValues: {
      fullName: '',
      email: '',
      subject: '',
      message: '',
    },
  });

  const onSubmit: SubmitHandler<HelpPayload> = (data) => {
    authImplementation?.help &&
      authImplementation.help(
        data,
        () => {
          setSended(true);
        },
        () => {
          setResult(t('errors.mail error'));
        },
      );
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <InputWrapper>
          <Controller
            name="fullName"
            control={control}
            render={({ field }) => (
              <Input
                errorFlag={Boolean(errors.fullName)}
                message={errors?.fullName?.message ?? ''}
                field={field}
                label={t('full name')}
              />
            )}
          />
        </InputWrapper>
        <InputWrapper>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <Input
                errorFlag={Boolean(errors.email)}
                message={errors?.email?.message ?? ''}
                field={field}
                label={t('email')}
              />
            )}
          />
        </InputWrapper>
        <InputWrapper>
          <Controller
            name="subject"
            control={control}
            render={({ field }) => (
              <Input
                errorFlag={Boolean(errors.subject)}
                message={errors?.subject?.message ?? ''}
                field={field}
                label={t('subject')}
              />
            )}
          />
        </InputWrapper>
        <InputWrapper>
          <Controller
            name="message"
            control={control}
            render={({ field }) => (
              <Input
                errorFlag={Boolean(errors.subject)}
                message={errors?.subject?.message ?? ''}
                field={field}
                label={t('message')}
                multiline
                minRows={8}
              />
            )}
          />
        </InputWrapper>
        <InputWrapper>
          <Button type="submit" variant="contained">
            {t('send')}
          </Button>
        </InputWrapper>
      </form>
      <InputWrapper>
        <Error message={result} />
      </InputWrapper>
    </>
  );
};

export default HelpForms;
